// removed by extract-text-webpack-plugin
module.exports = {"footprint-deprecation-notice-wrap":"footprint-deprecation-notice-wrap___2J18w center___2iqBf","footprint-deprecation-notice-icon":"footprint-deprecation-notice-icon___2HUSY","footprint-deprecation-notice-text":"footprint-deprecation-notice-text___8ICZ_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FootprintDeprecated/FootprintDeprecated.css
// module id = 910
// module chunks = 0